module.exports = __webpack_public_path__ + "assets/51106b8796e1132f289504a25cacbc2b.mp3";